/* eslint-disable react/no-access-state-in-setstate */
/* eslint-disable extra-rules/no-commented-out-code,max-lines */
/* istanbul ignore file */
// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';
import Col from '@tcp/core/src/components/common/atoms/Col';
import Row from '@tcp/core/src/components/common/atoms/Row';
import Image from '@tcp/core/src/components/common/atoms/Image';
import Anchor from '@tcp/core/src/components/common/atoms/Anchor';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import internalEndpoints from '@tcp/core/src/components/features/account/common/internalEndpoints';
import DynamicModule from '@tcp/core/src/components/common/atoms/DynamicModule';
import withStyles from '@tcp/core/src/components/common/hoc/withStyles';
import { getWishListbyId } from '@tcp/core/src/services/abstractors/productListing/favorites';
import { getCartItemCount } from '@tcp/core/src/utils/cookie.util';
import { breakpoints } from '@tcp/core/styles/themes/TCP/mediaQuery';
import {
  getIconPath,
  routerPush,
  getViewportInfo,
  isClient,
  removeSessionStorage,
  updateStoreDataLocalStorage,
} from '@tcp/core/src/utils';
import Modal from '@tcp/core/src/components/common/molecules/Modal';
import { callNavigateAPIForExternalLinks, isCanada } from '@tcp/core/src/utils/utils';
import { SHOP_THIS_STORE_SCROLL } from '@tcp/core/src/constants/shopThisStore.constant';
import { getLocalStorage } from '@tcp/core/src/utils/localStorageManagement';
import {
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '@tcp/core/src/utils/labels/labelUtilty';
import { getStoreFilterData } from '@tcp/core/src/components/features/browse/ShopThisStore/container/ShopThisStore.utils';
import NewSearchBar from '@tcp/core/src/components/common/molecules/NewSearchBar';
import HeaderLabels, { GLOBAL_LABELS } from '../../labels/HeaderNew.labels';
import Navigation from '../../../Navigation';
import BrandTabs from '../BrandTabs';
import CountrySelector from '../CountrySelector';
import { keyboard, brand } from '../../../../../../constants/constants';
import style, { customHeaderStyle, NavigationRow, NavigationColumn } from './HeaderMiddleNav.style';
import { UserIcon, CartIcon, WishlistIcon } from '../HeaderIcons/HeaderSvgIcons';

const StoreLocatorLink = dynamic(() =>
  import(/* webpackChunkName: "store-locator-link" */ '../StoreLocatorLink')
);

const StoreLocatorModal = dynamic(
  () =>
    import(
      /* webpackChunkName: "stor-locator-modal" */
      '@tcp/core/src/components/common/organisms/StoreLocatorModal'
    ),
  { ssr: false }
);

const SearchBar = dynamic(() =>
  import(
    /* webpackChunkName: "search-bar-old" */ '@tcp/core/src/components/common/molecules/SearchBar'
  )
);

const WishlistModal = dynamic(() => import(/* webpackChunkName: "wishlist-modal" */ '../Wishlist'));

const NewHeaderAccountDrawerView = dynamic(() =>
  import(
    /* webpackChunkName: "new-header-account-drawer" */ '../../views/NewHeaderAccountDrawer.view'
  )
);

const NewHeaderLoginDrawerView = dynamic(() =>
  import(/* webpackChunkName: "new-header-login-drawer" */ '../../views/NewHeaderLoginDrawer.view')
);

const LoggedInUserInfo = dynamic(() =>
  import(/* webpackChunkName: "loggedin-user" */ '../LoggedInUserInfo/view/LoggedInUserInfo')
);

// Move this function to a common utility function
const getProductImagePath = (id, excludeExtension, imageExtension) => {
  const imageName = (id && id.split('_')) || [];
  const imagePath = imageName[0];
  const extension = imageExtension ? `.${imageExtension}` : '.jpg';

  return {
    125: `${imagePath}/${id}${excludeExtension ? '' : extension}`,
    380: `${imagePath}/${id}${excludeExtension ? '' : extension}`,
    500: `${imagePath}/${id}${excludeExtension ? '' : extension}`,
    900: `${imagePath}/${id}${excludeExtension ? '' : extension}`,
  };
};

const getImgPath = (id, excludeExtension, imageExtension) => {
  return {
    colorSwatch: null,
    productImages: getProductImagePath(id, excludeExtension, imageExtension),
  };
};

/**
 * This function handles opening and closing for Navigation drawer on mobile and tablet viewport
 * @param {Function} openNavigationDrawer Function to dispatch open drawer action to store
 * @param {Function} closeNavigationDrawer  Function to dispatch close drawer action to store
 * @param {Boolean} isOpen Flag to determine if drawer is open
 */
const handleNavigationDrawer = (openNavigationDrawer, closeNavigationDrawer, isOpen) => () => {
  setTimeout(() => {
    return isOpen ? closeNavigationDrawer('l1_drawer') : openNavigationDrawer('l1_drawer');
  }, 0);
};
class HeaderMiddleNav extends React.PureComponent {
  globalLabels = getLabelFromCopyOrFromTranslation(GLOBAL_LABELS, HeaderLabels);

  constructor(props) {
    super(props);
    const { isLoggedIn, cartItemCount } = props;
    this.isTabPressed = false;
    this.state = {
      userNameClick: true,
      triggerLoginCreateAccount: true,
      isLoggedIn: isLoggedIn || false,
      cartItemCount,
      showStoreDetails: false,
      showChangeStoreModal: false,
      showWishList: false,
      favorites: null,
      hasMounted: false,
    };
    this.isBagCtaHovered = false;
    this.colSize = {
      variant1: {
        large: 4,
        medium: 12,
        small: 12,
      },
      variant2: {
        large: 0,
        medium: 1,
        small: 1,
      },
      variant3: {
        large: 8,
        medium: 7,
        small: 5,
      },
      variant4: {
        large: 12,
        medium: 8,
        small: 6,
      },
    };

    this.ignoreGutter = {
      variant1: { large: true },
      variant2: { small: true, medium: true, large: true },
    };
  }

  componentDidMount() {
    this.setState({ hasMounted: true });
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const { isLoggedIn: prevLoggedInState, cartItemCount, isOpenAddedToBag } = prevState;
    const {
      isLoggedIn: nextLoggedInState,
      totalItems,
      isOpenAddedToBag: nextIsOpenAddedToBag,
    } = nextProps;
    if (
      prevLoggedInState !== nextLoggedInState ||
      totalItems !== cartItemCount ||
      (isOpenAddedToBag !== nextIsOpenAddedToBag && nextIsOpenAddedToBag === true)
    ) {
      return { cartItemCount: getCartItemCount() || totalItems };
    }
    return null;
  }

  onLinkClick = ({ openOverlay, navname }, componentToOpen) => {
    const { setClickAnalyticsData, isOpenOverlay, closeOverlay, showFullPageAuth } = this.props;
    const { pathname = 'referrer' } = (window && window.location) || {};
    setClickAnalyticsData({
      eventName: 'Click_Navigation_v97',
      pageNavigationText: navname,
      nav_cd171: 'header-my-account',
      customEvents: ['event82'],
    });

    if (showFullPageAuth && componentToOpen === 'createAccount') {
      routerPush(`/home?target=register&successtarget=${pathname}`, '/home/register');
    } else if (showFullPageAuth && componentToOpen === 'login') {
      routerPush(`/home?target=login&successtarget=${pathname}`, '/home/login');
    } else {
      if (!isOpenOverlay) {
        openOverlay({
          component: componentToOpen,
          variation: 'primary',
        });
      }
      closeOverlay();
    }

    this.closeNavDrawer();
  };

  renderAccountInfoSection = (
    userName,
    openOverlay,
    isUserPlcc,
    userPoints,
    userRewards,
    isRememberedUser
  ) => {
    const { userNameClick } = this.state;
    const { isOpenOverlay, isLoggedIn, brandId, onLoginIconClick, showCondensedHeader } =
      this.props;
    const onAccountLinkClick = this.onNewAccountDrawerToggle;

    return userName && (isLoggedIn || isRememberedUser) ? (
      <LoggedInUserInfo
        mainId="accountDrawer"
        userName={userName}
        userPoints={userPoints}
        userRewards={userRewards}
        userNameClick={userNameClick}
        openOverlay={openOverlay}
        isOpenOverlay={isOpenOverlay}
        onLinkClick={onAccountLinkClick}
        isDrawer={false}
        isUserPlcc={isUserPlcc}
        fromCondensedHeader={showCondensedHeader}
        brandId={brandId}
      />
    ) : (
      <BodyCopy
        id="non-login-user"
        component="div"
        onKeyPress={onLoginIconClick}
        onClick={onLoginIconClick}
      >
        <UserIcon brand={brandId} />
      </BodyCopy>
    );
  };

  handleKeyDown = (event, openNavigationDrawer, closeNavigationDrawer, isNavigationDrawerOpen) => {
    const { KEY_ENTER, KEY_SPACE, KEY_ESCAPE } = keyboard;
    const { which } = event;
    if (which === KEY_ENTER || which === KEY_SPACE || which === KEY_ESCAPE) {
      handleNavigationDrawer(openNavigationDrawer, closeNavigationDrawer, isNavigationDrawerOpen)();
    }
  };

  updateCartItemCount = () => {
    const { totalItems } = this.props;
    this.setState({
      cartItemCount: getCartItemCount() || totalItems,
    });
  };

  miniBagOnHover = (e) => {
    if (e) e.preventDefault();
    const { minibagOnHoverEnabled } = this.props;
    this.isBagCtaHovered = true;
    const isLoginCheckout =
      window.location.pathname.indexOf('/login-checkout') !== -1 ||
      window.location.pathname.indexOf('/register-checkout') !== -1;
    if (
      minibagOnHoverEnabled &&
      !isLoginCheckout &&
      window &&
      window.innerWidth > breakpoints.values.lg
    ) {
      const { openMiniBagDispatch, closedOverlay } = this.props;
      const timeoutRef = setTimeout(() => {
        if (this.isBagCtaHovered) {
          openMiniBagDispatch();
          closedOverlay();
        }
        clearTimeout(timeoutRef);
      }, 300);
    }
    this.closeNavDrawer();
  };

  onDefocus = (e) => {
    if (e) e.preventDefault();
    this.isBagCtaHovered = false;

    if (this.isTabPressed) {
      const { closeMiniBagDispatch } = this.props;
      closeMiniBagDispatch();
    }
  };

  handleCartKeyDown = (e) => {
    if (e.key === 'Tab') {
      this.isTabPressed = true;
    }
  };

  miniBagOnClick = ({ e }) => {
    if (e) e.preventDefault();
    requestAnimationFrame(() => {
      const { trackAnalyticsClick } = this.props;
      trackAnalyticsClick(
        { nav_cd171: 'header-cart', customEvents: ['event82'] },
        { name: 'header-cart' }
      );
      routerPush('/bag', '/bag');
    });
  };

  closeNavDrawer = () => {
    const { navigationDrawer, closeNavigationDrawer } = this.props;
    this.setState({
      showStoreDetails: false,
    });
    if (navigationDrawer && navigationDrawer.open) {
      closeNavigationDrawer('l1_drawer');
    }
  };
  /**
   * This function will handle click to go to respective links
   * @param {event, link, path} -
   */

  onLinkRedirect = ({ e, link, path }) => {
    e.preventDefault();
    requestAnimationFrame(() => {
      const { trackAnalyticsClick, isGuestFavEnabled } = this.props;
      trackAnalyticsClick(
        { nav_cd171: 'header-wishlist-icon', customEvents: ['event82'] },
        { name: 'header-wishlist-icon' }
      );
      const { closedOverlay, isLoggedIn } = this.props;

      if (isLoggedIn || (!isLoggedIn && isGuestFavEnabled)) {
        routerPush(link, path);
      } else {
        const { pathname = 'referrer' } = (window && window.location) || {};
        routerPush(`/home?target=login&successtarget=${pathname}`, '/home/login');
      }
      closedOverlay();
    });
  };

  handleStorePinClicked = () => {
    const { calcHeightFromTop, trackAnalyticsClick } = this.props;
    const { showStoreDetails } = this.state;
    requestAnimationFrame(() => {
      calcHeightFromTop();
      if (!showStoreDetails) {
        trackAnalyticsClick(
          { nav_cd171: 'header-locator-icon', customEvents: ['event82'] },
          { name: 'header-locator-icon' }
        );
      }
      this.setState({ showStoreDetails: !this.state.showStoreDetails });
    });
  };

  handleChangeStoreClick = (storeName) => {
    const { showStoreDetails } = this.state;
    requestAnimationFrame(() => {
      if (showStoreDetails) {
        const { trackAnalyticsClick } = this.props;
        trackAnalyticsClick(
          {
            nav_cd171: storeName
              ? 'shopthestore-header-select a different store'
              : 'shopthestore-header-select store',
            customEvents: ['event82'],
          },
          {
            name: storeName
              ? 'shopthestore-header-select a different store'
              : 'shopthestore-header-select store',
          }
        );
      }
      this.setState({
        showStoreDetails: false,
        showChangeStoreModal: !this.state.showChangeStoreModal,
      });
    });
  };

  handleShopThisStoreClick = (basicInfo) => {
    const { trackStsClick } = this.props;
    trackStsClick(
      {
        nav_cd171: 'shopthestore-header-shop this store',
        customEvents: ['event82'],
        eventCategory: 'store',
        eventAction: 'shop this store: top navigation',
        pageNavigationText: basicInfo?.storeName,
      },
      { name: 'shopthestore-header-shop this store' }
    );
    this.setState({
      showStoreDetails: false,
    });
    removeSessionStorage(SHOP_THIS_STORE_SCROLL);
    routerPush(
      `/search?search/shop-this-store?searchQuery=*&bopisStoreId=${encodeURIComponent(
        getStoreFilterData()
      )}&sort=newest_score desc`,
      `/search/shop-this-store?bopisStoreId=${encodeURIComponent(
        getStoreFilterData()
      )}&sort=newest_score desc`
    );
  };

  displayLoginModal = (event) => {
    event.preventDefault();
  };

  getFavoriteData = () => {
    const { userName, setFavData, userWishListId } = this.props;
    if (userWishListId) {
      getWishListbyId({
        wishListId: userWishListId,
        userName,
        guestAccessKey: null,
        isCanada: isCanada(),
        imageGenerator: getImgPath,
      }).then((res) => {
        setFavData(res);
      });
    }
  };

  showWishlistModal = () => {
    const { defaultWishList, activeWishList, isLoggedIn, calcHeightFromTop } = this.props;
    calcHeightFromTop();
    let tmp;
    if (isLoggedIn) {
      if (defaultWishList === null && activeWishList === null) {
        this.getFavoriteData();
      }
      if (window?.innerWidth > 1200) {
        if (defaultWishList === null) {
          if (activeWishList === null) {
            tmp = null;
          } else {
            tmp = activeWishList;
          }
        } else {
          tmp = defaultWishList;
        }
        const timeoutRef = setTimeout(() => {
          this.setState({
            showWishList: true,
            favorites: tmp,
          });
          clearTimeout(timeoutRef);
        }, 300);
      }
    }
  };

  onWishlistClose = () => {
    this.setState({
      showWishList: false,
    });
  };

  modalOpenCheck = (valueToReturn, isTablet, showCondensedHeader) => {
    return !(isTablet && showCondensedHeader) ? valueToReturn : false;
  };

  isModalToOpenCheck = (isSearchOpen, isFullSizeSearchModalOpen) => {
    return isSearchOpen && isFullSizeSearchModalOpen;
  };

  renderHeaderLoginView = ({
    isLoginModalOpen,
    onLoginIconClick,
    triggerLoginCreateAccount,
    userPoints,
    userRewards,
    userName,
    userNameClick,
    openOverlay,
    showCondensedHeader,
    isDrawerTransitionEnabled,
  }) => {
    if (isLoginModalOpen && !showCondensedHeader) {
      return (
        <NewHeaderLoginDrawerView
          isOpen={isLoginModalOpen}
          onClose={onLoginIconClick}
          triggerLoginCreateAccount={triggerLoginCreateAccount}
          onLinkClick={this.onLinkClick}
          userPoints={userPoints}
          userRewards={userRewards}
          isDrawer={false}
          userName={userName}
          userNameClick={userNameClick}
          openOverlay={openOverlay}
          fromCondensedHeader={showCondensedHeader}
          isDrawerTransitionEnabled={isDrawerTransitionEnabled}
        />
      );
    }

    return null;
  };

  onNewAccountDrawerToggle = () => {
    requestAnimationFrame(() => {
      const { accountDrawerOpen, openAccountDrawerDispatch, closeAccountDrawerDispatch } =
        this.props;
      if (accountDrawerOpen) {
        closeAccountDrawerDispatch();
      } else {
        openAccountDrawerDispatch();
      }
    });
  };

  renderNewAccountDrawer = (
    accountDrawerOpen,
    userName,
    fromCondensedHeader,
    isDrawerTransitionEnabled
  ) => {
    return accountDrawerOpen ? (
      <NewHeaderAccountDrawerView
        isOpen={accountDrawerOpen}
        onClose={this.onNewAccountDrawerToggle}
        userName={userName}
        fromCondensedHeader={fromCondensedHeader}
        isDrawerTransitionEnabled={isDrawerTransitionEnabled}
      />
    ) : null;
  };

  shouldShowStoreLocatorLinkFunc = (brandId, hideIcon) =>
    brandId !== brand.SNJ && brandId !== brand.PJP && !hideIcon;

  hideIconFunc = (isHamburgerMenuRedesignEnabled) => {
    return (
      isHamburgerMenuRedesignEnabled && (getViewportInfo().isMobile || getViewportInfo()?.isTablet)
    );
  };

  getDefaultStore = () => {
    return JSON.parse(getLocalStorage('defaultStore')) || '';
  };

  timeStampExistingCheck = (store) => {
    return !store?.favStoreTimeStamp && !store?.akamaiStoreTimeStamp;
  };

  timeStampCheck = (currentStore, storeToBeWrittenToLocalStorage) => {
    // Making sure store getting written to local storage has a newer timestamp and is a newer version.
    const currentStoreTimeStamp =
      currentStore?.favStoreTimeStamp || currentStore?.akamaiStoreTimeStamp;
    const storeToBeWrittenToLocalStorageTimeStamp =
      storeToBeWrittenToLocalStorage?.favStoreTimeStamp ||
      storeToBeWrittenToLocalStorage?.akamaiStoreTimeStamp;
    if (currentStoreTimeStamp && storeToBeWrittenToLocalStorageTimeStamp) {
      return new Date(currentStoreTimeStamp) < new Date(storeToBeWrittenToLocalStorageTimeStamp);
    }
    return false;
  };

  shouldUpdateStoreinStorage = (store, shouldShowStoreLocatorLink) => {
    if (!shouldShowStoreLocatorLink && store) {
      const storeToBeWrittenToLocalStorage = store;
      const currentDate = new Date();
      if (this.timeStampExistingCheck(store)) {
        storeToBeWrittenToLocalStorage.favStoreTimeStamp = currentDate;
      }
      const currentStore = this.getDefaultStore();
      if (
        store?.basicInfo?.storeName !== '' &&
        (this.timeStampCheck(currentStore, storeToBeWrittenToLocalStorage) ||
          !currentStore ||
          currentStore === '')
      ) {
        updateStoreDataLocalStorage(storeToBeWrittenToLocalStorage); // set only if current timestamp is older
      }
    }
  };

  renderSearchBar() {
    const {
      isSearchOpen,
      isFullSizeSearchModalOpen,
      setSearchState,
      onCloseClick,
      showCondensedHeader,
      trackAnalyticsClick,
      isSearchEnhancementRedesignEnabled,
      isSearchBarAlignmentEnabled,
    } = this.props;
    const isTablet = isClient() ? getViewportInfo().isTablet : null;

    if (isSearchBarAlignmentEnabled) {
      return (
        <NewSearchBar
          closeNavDrawer={this.closeNavDrawer}
          trackAnalyticsClick={trackAnalyticsClick}
        />
      );
    }
    return (
      <>
        {isFullSizeSearchModalOpen && !isSearchEnhancementRedesignEnabled ? (
          <Modal
            isOpen={this.isModalToOpenCheck(isSearchOpen, isFullSizeSearchModalOpen)}
            onRequestClose={this.handleShowHideFullSizeModalClick}
            overlayClassName="TCPModal__Overlay"
            className="TCPModal__Content"
            widthConfig={{ small: '375px', medium: '765px', large: '1023px' }}
            heightConfig={{ height: '99%' }}
            fixedWidth
            inheritedStyles={customHeaderStyle}
            headingAlign="center"
            horizontalBar={false}
            stickyCloseIcon
            fullWidth
            stickyHeader
          >
            <SearchBar
              className={!isSearchOpen}
              setSearchState={setSearchState}
              isSearchOpen={isSearchOpen}
              onCloseClick={onCloseClick}
              isFullSizeSearchModalOpen={isFullSizeSearchModalOpen}
              fromCondensedHeader={showCondensedHeader}
              trackAnalyticsClick={trackAnalyticsClick}
              isSearchEnhancementRedesignEnabled={isSearchEnhancementRedesignEnabled}
            />
          </Modal>
        ) : (
          <div className="headerSearchBox-wrapper-new">
            <SearchBar
              className="headerSearchBox-new"
              setSearchState={setSearchState}
              isSearchOpen={this.modalOpenCheck(isSearchOpen, isTablet, showCondensedHeader)}
              onCloseClick={onCloseClick}
              isFullSizeSearchModalOpen={this.modalOpenCheck(
                isFullSizeSearchModalOpen,
                isTablet,
                showCondensedHeader
              )}
              fromCondensedHeader={showCondensedHeader}
              trackAnalyticsClick={trackAnalyticsClick}
              isSearchEnhancementRedesignEnabled={isSearchEnhancementRedesignEnabled}
            />
          </div>
        )}
      </>
    );
  }

  // eslint-disable-next-line complexity, sonarjs/cognitive-complexity
  render() {
    const {
      className,
      openNavigationDrawer,
      closeNavigationDrawer,
      navigationDrawer,
      openOverlay,
      isUserPlcc,
      userName,
      userPoints,
      userRewards,
      store,
      isRememberedUser,
      onRouteChangeGlobalActions,
      isSearchOpen,
      showCondensedHeader,
      showMiniBag,
      brandId,
      onLoginIconClick,
      brandTabs,
      isLoginModalOpen,
      trackClickAnalyticsBopisFilter,
      headerMiddleNavHeight,
      trackAnalyticsClick,
      isNewNavigationImagesEnabled,
      checkNavImagesFlag,
      isShopThisStoreEnabled,
      accountDrawerOpen,
      defaultStore,
      isHamburgerMenuRedesignEnabled,
      isGuestFavEnabled,
      convertedBossUnavailableList,
      isDrawerTransitionEnabled,
      isHeaderStickyNav,
      isStickyHeaderBgColorEnabled,
      resetCurrentStoreInfo,
    } = this.props;
    const {
      userNameClick,
      triggerLoginCreateAccount,
      cartItemCount,
      showStoreDetails,
      showChangeStoreModal,
      showWishList,
      favorites,
      hasMounted,
    } = this.state;
    const closeIconButton = renderLabel(
      this.globalLabels?.accessibility?.closeIconButton,
      'closeIconButton'
    );
    const cartIconButton = renderLabel(
      this.globalLabels?.accessibility?.cartIconButton,
      'cartIconButton'
    );
    const favoriteIconButton = renderLabel(
      this.globalLabels?.accessibility?.favoriteIconButton,
      'favoriteIconButton'
    );
    const hamburgerMenu = renderLabel(
      this.globalLabels?.accessibility?.hamburgerMenu,
      'hamburgerMenu'
    );
    const brandTabsClassName = `header-topnav-brand-tabs header-topnav__brand-tabs_SNJ`;
    const hideIcon = hasMounted && this.hideIconFunc(isHamburgerMenuRedesignEnabled);
    const shouldShowStoreLocatorLink = hasMounted
      ? this.shouldShowStoreLocatorLinkFunc(brandId, hideIcon)
      : brandId !== brand.SNJ && brandId !== brand.PJP;
    this.shouldUpdateStoreinStorage(store, shouldShowStoreLocatorLink);
    return (
      <React.Fragment>
        <NavigationRow
          className={`${className} header-middle-nav`}
          ignoreGutter={this.ignoreGutter.variant1}
          id="headerMiddleNav"
          isStickyHeaderNav={isHeaderStickyNav}
        >
          <Row className="content-wrapper-nav" id="contentWrapperNav">
            <Col
              colSize={this.colSize.variant1}
              ignoreGutter={this.ignoreGutter.variant2}
              className="brands-wrapper"
            >
              <div className={brandTabsClassName}>
                <BrandTabs
                  data={brandTabs}
                  trackAnalyticsClick={trackAnalyticsClick}
                  isStickyHeaderBgColorEnabled={isStickyHeaderBgColorEnabled}
                />
              </div>
            </Col>
            <Col
              className="header-middle-nav-search"
              colSize={this.colSize.variant2}
              ignoreGutter={this.ignoreGutter.variant2}
            >
              <Image
                src={navigationDrawer.open ? getIconPath('mobile-close-dark') : getIconPath('menu')}
                alt="hamburger menu"
                role="button"
                tabIndex="0"
                aria-label={navigationDrawer.open ? closeIconButton : hamburgerMenu}
                className="hamburger-menu"
                onClick={handleNavigationDrawer(
                  openNavigationDrawer,
                  closeNavigationDrawer,
                  navigationDrawer.open
                )}
                onKeyDown={(e) =>
                  this.handleKeyDown(
                    e,
                    openNavigationDrawer,
                    closeNavigationDrawer,
                    navigationDrawer.open
                  )
                }
                data-locator={navigationDrawer.open ? 'L1_menu_close_Btn' : 'menu_bar_icon'}
              />
            </Col>
            <Col
              colSize={this.colSize.variant3}
              ignoreGutter={this.ignoreGutter.variant2}
              className={`textRight header-middle-login-section ${isSearchOpen && 'flexbox'}`}
            >
              <div className="content-wrapper-left">
                {this.renderSearchBar()}
                <CountrySelector
                  trackAnalyticsClick={trackAnalyticsClick}
                  isStickyHeaderBgColorEnabled={isStickyHeaderBgColorEnabled}
                />
              </div>
              <div className="content-wrapper-right">
                {shouldShowStoreLocatorLink && (
                  <div>
                    <StoreLocatorLink
                      store={store}
                      onLinkClick={this.closeNavDrawer}
                      brandId={brandId}
                      showStoreDetails={showStoreDetails}
                      onStorePinClicked={this.handleStorePinClicked}
                      handleChangeStoreClick={this.handleChangeStoreClick}
                      handleShopThisStoreClick={this.handleShopThisStoreClick}
                      headerMiddleNavHeight={headerMiddleNavHeight}
                      fromCondensedHeader={showCondensedHeader}
                      isShopThisStoreEnabled={isShopThisStoreEnabled}
                      resetCurrentStoreInfo={resetCurrentStoreInfo}
                    />
                  </div>
                )}
                {!hideIcon && (
                  <div>
                    <Anchor
                      to=""
                      id="wishlistIcon"
                      aria-label={`${favoriteIconButton} item`}
                      className=""
                      onClick={(e) =>
                        this.onLinkRedirect({
                          e,
                          link: internalEndpoints.favorites.link,
                          path: internalEndpoints.favorites.path,
                        })
                      }
                      fontSizeVariation="large"
                      anchorVariation="primary"
                      noLink
                    >
                      <WishlistIcon brand={brandId} />
                    </Anchor>
                  </div>
                )}
                {this.renderAccountInfoSection(
                  userName,
                  openOverlay,
                  isUserPlcc,
                  userPoints,
                  userRewards,
                  isRememberedUser
                )}
                {this.renderHeaderLoginView({
                  isLoginModalOpen,
                  onLoginIconClick,
                  triggerLoginCreateAccount,
                  userPoints,
                  userRewards,
                  userName,
                  userNameClick,
                  openOverlay,
                  headerMiddleNavHeight,
                  showCondensedHeader,
                  isDrawerTransitionEnabled,
                })}

                <Anchor
                  to=""
                  id="cartIcon"
                  aria-label={`${cartIconButton} ${cartItemCount} item`}
                  className=""
                  onClick={(e) => this.miniBagOnClick({ e })}
                  onMouseOver={(e) => this.miniBagOnHover(e)}
                  onMouseOut={(e) => this.onDefocus(e)}
                  onBlur={(e) => this.onDefocus(e)}
                  onKeyDown={this.handleCartKeyDown}
                  fontSizeVariation="large"
                  anchorVariation="primary"
                  noLink
                >
                  <CartIcon brand={brandId} />
                  <BodyCopy
                    className="cartCount"
                    component="span"
                    fontWeight="semibold"
                    fontSize="fs10"
                    aria-hidden="true"
                    tabIndex="-1"
                  >
                    {hasMounted ? convertedBossUnavailableList?.length || cartItemCount || 0 : 0}
                  </BodyCopy>
                </Anchor>
              </div>
            </Col>
          </Row>
        </NavigationRow>
        <Row
          fullBleed={{
            small: true,
            medium: true,
            large: true,
          }}
          onClick={callNavigateAPIForExternalLinks}
        >
          <NavigationColumn
            className="header-middle-nav-bar"
            id="header-middle-nav"
            colSize={this.colSize.variant4}
            isHeaderStickyNav={isHeaderStickyNav}
            isNewNavigationImagesEnabled={isNewNavigationImagesEnabled}
          >
            <Navigation
              openNavigationDrawer={navigationDrawer.open}
              closeNavigationDrawer={!navigationDrawer.open}
              closeNav={closeNavigationDrawer}
              userName={userName}
              userPoints={userPoints}
              userRewards={userRewards}
              userNameClick={userNameClick}
              onLinkClick={this.onLinkClick}
              triggerLoginCreateAccount={triggerLoginCreateAccount}
              onRouteChangeGlobalActions={onRouteChangeGlobalActions}
              brandId={brandId}
              showCondensedHeader={showCondensedHeader}
              isGuestFavEnabled={isGuestFavEnabled}
            />
          </NavigationColumn>
        </Row>

        {showMiniBag && (
          <DynamicModule
            importCallback={() =>
              import('@tcp/web/src/components/features/CnC/MiniBag/container/MiniBag.container')
            }
            isOpen={showMiniBag}
            userName={userName}
            updateCartItemCount={this.updateCartItemCount}
            fromCondensedHeader={showCondensedHeader}
            isNewNavigationImagesEnabled={isNewNavigationImagesEnabled}
            checkNavImagesFlag={checkNavImagesFlag}
          />
        )}
        {showChangeStoreModal && (
          <StoreLocatorModal
            isOpen={showChangeStoreModal}
            onClose={this.handleChangeStoreClick}
            onStoreChange={() => this.onStoreChange}
            trackClickAnalyticsBopisFilter={trackClickAnalyticsBopisFilter}
            fromCondensedHeader={showCondensedHeader}
            trackAnalyticsClick={trackAnalyticsClick}
            modalStoreSearchData={defaultStore}
          />
        )}
        {showWishList && (
          <WishlistModal
            showWishList={showWishList}
            className={className}
            onWishlistClose={this.onWishlistClose}
            favourites={favorites}
            onLinkRedirect={this.onLinkRedirect}
            internalEndpoints={internalEndpoints}
            wishlistModalTopDistance={headerMiddleNavHeight}
            fromCondensedHeader={showCondensedHeader}
          />
        )}
        {this.renderNewAccountDrawer(
          accountDrawerOpen,
          userName,
          showCondensedHeader,
          isDrawerTransitionEnabled
        )}
      </React.Fragment>
    );
  }
}

HeaderMiddleNav.propTypes = {
  className: PropTypes.string.isRequired,
  navigationDrawer: PropTypes.arrayOf(PropTypes.shape({})),
  openNavigationDrawer: PropTypes.func.isRequired,
  closeNavigationDrawer: PropTypes.func.isRequired,
  isUserPlcc: PropTypes.bool,
  userName: PropTypes.string,
  userPoints: PropTypes.string,
  userRewards: PropTypes.string,
  openOverlay: PropTypes.func.isRequired,
  closedOverlay: PropTypes.func.isRequired,
  isOpenOverlay: PropTypes.bool.isRequired,
  isLoggedIn: PropTypes.bool,
  cartItemCount: PropTypes.number,
  openMiniBagDispatch: PropTypes.func.isRequired,
  store: PropTypes.shape({
    basicInfo: PropTypes.shape({}),
    hours: PropTypes.shape({
      regularHours: PropTypes.shape([]),
      regularAndHolidayHours: PropTypes.shape([]),
      holidayHours: PropTypes.shape([]),
    }),
    features: PropTypes.shape({}),
  }),
  isRememberedUser: PropTypes.bool,
  setClickAnalyticsData: PropTypes.func.isRequired,
  closeOverlay: PropTypes.func,
  onRouteChangeGlobalActions: PropTypes.func,
  isSearchOpen: PropTypes.bool,
  isFullSizeSearchModalOpen: PropTypes.bool,
  onCloseClick: PropTypes.func,
  setSearchState: PropTypes.func,
  showCondensedHeader: PropTypes.bool,
  totalItems: PropTypes.number,
  showMiniBag: PropTypes.bool,
  showFullPageAuth: PropTypes.bool,
  minibagOnHoverEnabled: PropTypes.bool,
  defaultWishList: PropTypes.shape({}),
  activeWishList: PropTypes.shape({}),
  brandId: PropTypes.string,
  userWishListId: PropTypes.string,
  onLoginIconClick: PropTypes.func,
  setFavData: PropTypes.func,
  calcHeightFromTop: PropTypes.func,
  headerMiddleNavHeight: PropTypes.number,
  brandTabs: PropTypes.string,
  isLoginModalOpen: PropTypes.bool.isRequired,
  trackClickAnalyticsBopisFilter: PropTypes.func.isRequired,
  trackAnalyticsClick: PropTypes.func,
  isNewNavigationImagesEnabled: PropTypes.bool,
  isShopThisStoreEnabled: PropTypes.bool,
  accountDrawerOpen: PropTypes.bool,
  openAccountDrawerDispatch: PropTypes.func.isRequired,
  closeAccountDrawerDispatch: PropTypes.func.isRequired,
  isGuestFavEnabled: PropTypes.bool,
  isDrawerTransitionEnabled: PropTypes.bool,
  isHeaderStickyNav: PropTypes.bool,
  isStickyHeaderBgColorEnabled: PropTypes.bool,
};

HeaderMiddleNav.defaultProps = {
  navigationDrawer: {
    open: false,
  },
  store: {
    basicInfo: {
      id: '',
      storeName: '',
      phone: '',
      coordinates: {},
      address: {},
    },
    hours: {
      regularHours: [],
      regularAndHolidayHours: [],
      holidayHours: [],
    },
    features: {},
  },
  isRememberedUser: false,
  closeOverlay: () => {},
  onRouteChangeGlobalActions: () => {},
  onCloseClick: () => {},
  setSearchState: () => {},
  isSearchOpen: false,
  isFullSizeSearchModalOpen: false,
  showCondensedHeader: false,
  totalItems: 0,
  showMiniBag: false,
  showFullPageAuth: false,
  minibagOnHoverEnabled: false,
  isUserPlcc: false,
  userName: '',
  userPoints: '',
  userRewards: '',
  isLoggedIn: false,
  cartItemCount: 0,
  defaultWishList: null,
  activeWishList: null,
  brandId: '',
  brandTabs: '',
  onLoginIconClick: () => {},
  userWishListId: '',
  setFavData: () => {},
  calcHeightFromTop: () => {},
  headerMiddleNavHeight: 0,
  trackAnalyticsClick: () => {},
  isNewNavigationImagesEnabled: false,
  isShopThisStoreEnabled: false,
  accountDrawerOpen: false,
  isGuestFavEnabled: false,
  isDrawerTransitionEnabled: false,
  isHeaderStickyNav: false,
  isStickyHeaderBgColorEnabled: false,
};

export { HeaderMiddleNav as HeaderMiddleNavVanilla };

export default withStyles(HeaderMiddleNav, style);
